export default __webpack_public_path__ + "static/default_user-0d14c6999b4a5c8e86a7f06288265098.png";